export function activeTheme(state, data) {
  state.activeTheme = data
}

export function activeTab(state, data) {
  state.activeTab = data
}

export function activeTabMechanism(state, data) {
  state.activeTabMechanism = data
}

export function activeTabPlate(state, data) {
  state.activeTabPlate = data
}

export function preset(state, data) {
  state.preset = data
}

export function custom(state, data) {
  state.custom = data
}

export function cart(state, data) {
  state.cart = data
}

export function getTotalPrice(state, data) {
  state.getTotalPrice = data
}
